package one.healthium.cali.providers

import ifaandroid.apps.cali.composeapp.generated.resources.Res
import ifaandroid.apps.cali.composeapp.generated.resources.ic_checkmark_checked
import ifaandroid.apps.cali.composeapp.generated.resources.ic_checkmark_unchecked
import ifaandroid.apps.cali.composeapp.generated.resources.ic_splash
import one.healthium.ui.compose.components.IconsProvider
import org.jetbrains.compose.resources.DrawableResource

class AppIconsProvider : IconsProvider {
    override val icCheckMarkChecked: DrawableResource = Res.drawable.ic_checkmark_checked
    override val icCheckMarkUnchecked: DrawableResource = Res.drawable.ic_checkmark_unchecked
    override val appIcon: DrawableResource = Res.drawable.ic_splash
}

